<script setup>
import { ref, reactive } from 'vue';
import { router, useForm, Link } from '@inertiajs/vue3'
import JetActionSection from '@/Jetstream/ActionSection.vue';
import JetDialogModal from '@/Jetstream/DialogModal.vue';
import JetDangerButton from '@/Jetstream/DangerButton.vue';
import JetInput from '@/Jetstream/Input.vue';
import JetInputError from '@/Jetstream/InputError.vue';
import JetSecondaryButton from '@/Jetstream/SecondaryButton.vue';
import multiselect from '@vueform/multiselect';

const programme = router.page.props.ziggy.programme;
const organisation = router.page.props.ziggy.organisation;

const confirmingUserDeletion = ref(false);
const passwordInput = ref(null);
const deleteUserData = ref(false);

let urlNamePrefix = '';

if (organisation) {
    urlNamePrefix = "gi.";
} else if (!organisation && !programme) {
    urlNamePrefix = "platform.";

}

const props = defineProps({
    teamAdminUsers: Array,
    teamMemberUsers: Array,
    isOtherAdmins: Boolean,
    isMembers: Boolean,
    otherTeamMembers: Boolean
});

//const buttonsDisabled = (props.otherTeamMembers == true && props.isOtherAdmins == false) ? true : false;
const showAssignOwnerDD = (props.otherTeamMembers == true && props.isOtherAdmins == false && router.page.props.auth.user.id == router.page.props.auth.user.current_team.user_id) ? true : false;
const isOtherAdmins = props.isOtherAdmins;

console.log('Is other admins:' + props.isOtherAdmins);
console.log('Is other team members:' + props.otherTeamMembers);
console.log('Other team members:' + props.teamMemberUsers);

const form = useForm({
    password: '',
    user_id: 0,
    assignOwership: showAssignOwnerDD,
    emailAboutAssociatedData: false,
    otherTeamMembers: props.otherTeamMembers,
    isOtherAdmins: isOtherAdmins
});

const confirmUserDeletion = (requestDataDeletion) => {
    deleteUserData.value = requestDataDeletion;
    form.emailAboutAssociatedData = requestDataDeletion;
    confirmingUserDeletion.value = true;

    setTimeout(() => passwordInput.value.focus(), 250);
};

const deleteUser = () => {
    form.delete(route(urlNamePrefix+'current-user.destroy'), {
        preserveScroll: true,
        onSuccess: () => closeModal(),
        onError: () => passwordInput.value.focus(),
        onFinish: () => form.reset(),
    });
};

const closeModal = () => {
    confirmingUserDeletion.value = false;

    form.reset();
};

</script>

<template>
    <JetActionSection>
        <template #title>
            {{ $t('user.delete.title') }}
        </template>

        <template #description>
            {{ $t('user.delete.description') }}
        </template>

        <template #content>

            <div class="max-w-xl text-sm text-red-600 mb-3" v-if="buttonsDisabled == true">
                <p>{{ $t('user.delete.permanent.info') }}</p>
                <p>{{ $t('user.delete.permanent.admin_change_1') }}

                    <Link :href="route(urlNamePrefix+'teams.show', {team: $page.props.auth.user.current_team})" class="underline text-sm text-gray-600 hover:text-gray-900">
                        {{ $t('user.delete.permanent.admin_change_link') }}
                    </Link>

                    {{ $t('user.delete.permanent.admin_change_2') }} </p>
            </div>

            <div class="max-w-xl text-sm text-gray-600">
                {{ $t('user.delete.soft.info') }}
            </div>

            <div class="mt-5">
                <JetDangerButton @click="confirmUserDeletion(false)">
                    {{ $t('user.delete.delete_button') }}
                </JetDangerButton>
            </div>
            <br />
            <div class="max-w-xl text-sm text-gray-600">
                {{ $t('user.delete.hard.info') }}
            </div>

            <div class="mt-5">
                <JetDangerButton @click="confirmUserDeletion(true)">
                    {{ $t('user.delete.hard.button') }}
                </JetDangerButton>
                <div class="max-w-xl text-sm text-gray-600 mt-5">{{ $t('user.delete.info') }}</div>
            </div>

            <!-- Delete Account Confirmation Modal -->
            <JetDialogModal :show="confirmingUserDeletion" @close="closeModal">
                <template #title>
                    {{ $t('user.delete.title') }}
                </template>

                <template #content>

                    <div v-if="showAssignOwnerDD">

                        <p>{{ $t('user.delete.modal.owner') }}</p>

                        <multiselect
                            :disabled="preview"
                            :id="actionAssignUserAsAdmin"
                            :options="props.teamMemberUsers"
                            v-model="form.user_id"
                            label="full_name"
                            track-by="full_name"
                            valueProp="id"
                            placeholder="Assign Team Member to Admin Role"
                            :searchable="false"
                            :allow-empty="false"
                            @select="UpdateAssignedUser"
                            class="md:mr-5 w-full border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md mb-2 mt-2"
                        >
                        </multiselect>

                        <JetInputError :message="form.errors.assignedUser" class="mt-2" />

                        <input type="hidden" v-model="form.assignOwership" />
                        <input type="hidden" v-model="form.emailAboutAssociatedData" />
                        <input type="hidden" v-model="form.otherTeamMembers" />
                        <input type="hidden" v-model="form.isOtherAdmins" />

                    </div>

                    <p class="mt-5">{{ $t('user.delete.warning1') }}</p>
                    <p class="mt-5">{{ $t('user.delete.warning2') }}</p>
                    <p class="mt-5">{{ $t('user.delete.warning3') }}</p>

                    <p v-if="deleteUserData" class="mt-5">
                        {{ $t('user.delete.modal.info') }}
                    </p>

                    <p v-if="!otherTeamMembers" class="mt-5">
                        {{ $t('user.delete.modal.team_removal') }}
                    </p>

                    <div class="mt-4">
                        <JetInput
                            ref="passwordInput"
                            v-model="form.password"
                            type="password"
                            class="mt-1 block w-3/4"
                            :placeholder="$t('user.delete.password')"
                            @keyup.enter="deleteUser"
                        />

                        <JetInputError :message="form.errors.password" class="mt-2" />

                        <input type="hidden" v-model="form.isOtherAdmins" />

                    </div>
                </template>

                <template #footer>
                    <JetSecondaryButton @click="closeModal">
                        {{ $t('user.delete.cancel') }}
                    </JetSecondaryButton>

                    <JetDangerButton
                        class="ml-3"
                        :class="{ 'opacity-25': form.processing }"
                        :disabled="form.processing"
                        @click="deleteUser"
                    >
                        {{ $t('user.delete.confirm') }}
                    </JetDangerButton>
                </template>
            </JetDialogModal>
        </template>
    </JetActionSection>
</template>
